export const summitexitoso = {
    data: {
        leadId: "00QD5000009tCp2MAE",
        quotesResponse: false
     },
    error: false
};
